
import { useState, useEffect, useContext } from "react";

import OverviewBatteryFeatures from './OverviewBatteryFeature';
import Searches from './Search';
import ClientReportCode from './ClientReportCode'
function ClientReport(){

    const [ErrorInfo, setErrorInfo] = useState({
        id1: {
          name: "Central Office Pack",
          id: "2352kjjfa39919485hf248923g892h3",
          RackName: "Rack 1",
          BatteryName: "Battery 1",
          date: "14 June 2013",
          voltage: "67"
        },  id2: {
          name: "Deco Park",
          id: "2352kjjfa39919485hf248923g892h6",
          RackName: "Rack 2",
          BatteryName: "Battery 1",
          date: "14 June 2013",
          voltage: "64"
        }
      });

    return (
       
        <>
          <div className='OverviewContainer'  style={{paddingLeft: "240px", paddingRight: "80px"}}>
            <p className='dashboard_title'>Report</p>

           <Searches />

           { 
              Object.entries(ErrorInfo).map(([id, item]) =>  (

              <div key={item.id}>
               <ClientReportCode  name={item.name} id={item.id} date={item.date} RackName={item.RackName} BatteryName={item.BatteryName}  voltage={item.voltage} />
              </div>

                ))
            }

          
          </div>
        </>
    )
}

export default ClientReport;